module.exports = __webpack_public_path__ + "static/media/treeline-short.8525183b.png";